import { LayoutMode } from '../../types';
// eslint-disable-next-line import/no-cycle
import { ContinuousScrollingManager } from './ContinuousScrollingManager';
import { ScrollingManagerError } from './errors';
// eslint-disable-next-line import/no-cycle
import { HorizontalPaginatedScrollingManager } from './HorizontalPaginatedScrollingManager';
// eslint-disable-next-line import/no-cycle
import { ScrollingManager } from './ScrollingManager';
import type { MobileContentFrameWindow } from './types';
// eslint-disable-next-line import/no-cycle
import { VerticalPaginatedScrollingManager } from './VerticalPaginatedScrollingManager';

declare let window: MobileContentFrameWindow;

let scrollingManagerSingleton: ScrollingManager | undefined;
export function initScrollingManager(layoutMode: LayoutMode, windowParam = window) {
  if (scrollingManagerSingleton) {
    throw new ScrollingManagerError('Should not be initializing scrolling manager when one exists');
  }
  if (layoutMode === LayoutMode.VerticalPagination) {
    scrollingManagerSingleton = new VerticalPaginatedScrollingManager(windowParam);
  } else if (layoutMode === LayoutMode.HorizontalPagination) {
    scrollingManagerSingleton = new HorizontalPaginatedScrollingManager(windowParam);
  } else {
    scrollingManagerSingleton = new ContinuousScrollingManager(windowParam);
  }
  // for easier debugging
  windowParam.s = scrollingManagerSingleton;
  return scrollingManagerSingleton;
}
export function getScrollingManager(debugSource?: string) {
  if (!scrollingManagerSingleton) {
    throw new ScrollingManagerError(`[ignore-sentry] Attempted access of scrolling manager from ${debugSource} before its initialized`);
  }
  return scrollingManagerSingleton;
}

export function destroyScrollingManager() {
  if (!scrollingManagerSingleton) {
    return;
  }
  scrollingManagerSingleton.destroy();
  scrollingManagerSingleton = undefined;
  window.s = undefined;
}
